module.exports = require("express");


//////////////////
// WEBPACK FOOTER
// external "express"
// module id = 7
// module chunks = 0